<template>
  <div>
    <footer>
      <div class="footer-width">
        <!-- 頁腳-文字連結 -->
        <div class="footer-top">
          <div class="footer-link-list">
            <span>{{ $t('Bao.KatsuWIN') }}</span>
            <a @click.prevent="$router.push('/page/agent')">
              {{ $t('Bao.affiliate') }}
            </a>
            <a @click.prevent="$router.push('/page/support')">
              {{ $t('Bao.support_center_footer') }}
            </a>
            <a href="https://www.katsuwin.ai/blog/" target="_blank">
              {{ $t('Bao.blog_text') }}
            </a>
            <a @click.prevent="$router.push('/page/sup-faq')">
              {{ $t('Bao.faq_footer') }}
            </a>
            <a @click.prevent="$router.push('/page/cooperation')">
              {{ $t('Bao.become_agent') }}
            </a>
            <a href="https://katsuwinaffiliates.ai/" target="_blank">
              {{ $t('Bao.affiliates') }}
            </a>
          </div>
          <div v-if="gameType" class="footer-link-list">
            <template v-if="showBetting">
              <span>{{ $t('Bao.betting') }}</span>
              <a
                v-for="(type, key) in bettingSlice"
                :key="'betting'+key"
                @click="changeGameType(type)"
              >
                {{ type.name }}
              </a>
            </template>
            <template v-if="showGaming">
              <a
                v-for="(type, key) in gamingSlice"
                :key="'gaming'+key"
                @click="changeGameType(type)"
              >
                {{ type.name }}
              </a>
            </template>
          </div>

          <div class="footer-link-list">
            <span>{{ $t('Bao.useful_link') }}</span>
            <a @click.prevent="$router.push('/page/terms')">
              {{ $t('Bao.terms_conditions') }}
            </a>
            <a @click.prevent="$router.push('/page/rule')">
              {{ $t('Bao.game_rule') }}
            </a>
            <a @click.prevent="$router.push('/page/privacy')">
              {{ $t('Bao.agent_help_type_4') }}
            </a>
            <a @click.prevent="$router.push('/page/cookie-policy')">
              {{ $t('Bao.cookie_policy') }}
            </a>
            <a @click.prevent="$router.push('/page/sup-self-restraint')">
              {{ $t('Bao.res_gaming') }}
            </a>
          </div>
          <div v-if="followMedia !== undefined" class="footer-link-list icon-link">
            <div class="footer-link-list icon-link">
              <span>{{ $t('Bao.follow_us') }}</span>
              <ul>
                <li
                  v-for="(item, key) in followMedia"
                  :key="key"
                >
                  <a :href="item.link" :target="newWindows(item)">
                    <img :src="item.image" alt="">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- sns 手機版 -->
        <div class="footer-link-list-mb icon-link">
          <span>{{ $t('Bao.follow_us') }}</span>
          <ul>
            <li
              v-for="(item, key) in followMedia"
              :key="key"
            >
              <a :href="item.link" :target="newWindows(item)">
                <img :src="item.image" alt="">
              </a>
            </li>
          </ul>
        </div>

        <!-- 客服資訊 -->
        <div class="footer-help">
          <div class="footer-title">
            {{ $t('Bao.footer_help') }}
          </div>

          <div class="footer-help-list">
            <div @click="goHelpCenter">
              <img
                :src="getThemeImagePath('comments-question.svg')"
                alt="METHOD FOR USER TO CONTACT"
              >
              <p>{{ $t('Bao.chat_access') }}</p>
              <span><p>{{ $t('Bao.chat_start') }}</p></span>
              <p>{{ $t('Bao.chat_time') }}</p>
            </div>
            <div>
              <img :src="getThemeImagePath('email.svg')" alt="METHOD FOR USER TO CONTACT">
              <p>{{ $t('Bao.email_access') }}</p>
              <span><a href="mailto:support@katsuwin.ai"><p>support@katsuwin.ai</p></a></span>
              <p>24時間対応</p>
            </div>
          </div>
        </div>

        <!-- 銀行 -->
        <div class="footer-bank">
          <div class="footer-title">
            {{ $t('Bao.safe_payment') }}
          </div>

          <ul>
            <li v-for="(safePayment, key) in sortedImages" :key="key">
              <img :src="safePayment.image" :alt="safePayment.name">
            </li>
          </ul>
        </div>

        <!-- 遊戲供應商 -->
        <div class="footer-providers">
          <div class="footer-title">
            {{ $t('Bao.event_daily_attend_game_provider_setting') }}
          </div>

          <template v-if="main_image.sponsor_footer !== undefined">
            <ul class="footer_sponsor">
              <li v-for="(item, key) in main_image.sponsor_footer" :key="key">
                <img class="mw-100" :src="item.image" height="40" :alt="item.name">
              </li>
            </ul>
          </template>
        </div>

        <!-- 牌照 -->
        <div class="footer-licensed">
          <div class="footer-title">
            {{ $t('Bao.license') }}
          </div>
          <div
            id="anj-9b71cd6e-8774-4a76-a655-2ade6138fae4"
            data-anj-seal-id="9b71cd6e-8774-4a76-a655-2ade6138fae4"
            data-anj-image-size="48"
            data-anj-image-type="basic-small"
          />
          <div
            id="anj-5c72c516-517d-4335-bac9-33b0f916b5c3"
            data-anj-seal-id="5c72c516-517d-4335-bac9-33b0f916b5c3"
            data-anj-image-size="48"
            data-anj-image-type="basic-small"
          />
          <p>
            {{ $t('Bao.license_footer') }}
          </p>
        </div>

        <!-- k站簡介 -->
        <div class="footer-intro">
          <div class="footer-title">
            {{ $t('Bao.platform_intro') }}
          </div>
          <p>
            {{ $t('Bao.platform_intro_desc1') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc2')">
            {{ $t('Bao.platform_intro_desc2') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc3')">
            {{ $t('Bao.platform_intro_desc3') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc4')">
            {{ $t('Bao.platform_intro_desc4') }}
          </p>
        </div>

        <!-- 證照 -->
        <div class="footer-responsible">
          <div class="footer-title">
            {{ $t('Bao.footer_responsible') }}
          </div>

          <ul>
            <li>
              <img :src="getThemeImagePath('footer_gaming1.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="getThemeImagePath('footer_gaming2.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="getThemeImagePath('footer_gaming3.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="getThemeImagePath('footer_gaming4.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
          </ul>
        </div>

        <!-- 頁腳-版權 -->
        <div class="footer-Kcopyright">
          <p>Copyright © 2022 Katsuwin. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getTypeMenuInfo, getCategory } from '@/api/game'
import { getThemeImagePath, handleHelpCenterLink, newWindows, handleTokenUrl } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      main_image: null,
      licenseId: 16229799
    }
  },
  quickBars() {
    if (this.quickBars.length) {
      this.checkTokenUrl(this.licenseId)
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'gameType', 'brand', 'brandImage']),
    path() {
      return this.$route.path
    },
    banner() {
      return this.brand.banners[0]
    },
    sortedImages() {
      const images = [...this.brandImage.safe_payment]
      return images.sort((a, b) => a.sort - b.sort)
    },
    quickBars() {
      return this.brand.quickBars
    },
    followMedia() {
      return this.brandImage.follow_media
    },
    bettingSlice() {
      return this.gameType.slice(0, 4)
    },
    gamingSlice() {
      return this.gameType.slice(4, 8)
    },
    showBetting() {
      return this.bettingSlice.some(type => type.name !== '')
    },
    showGaming() {
      return this.gamingSlice.some(type => type.name !== '')
    }
  },
  mounted() {
    this.showSealBasedOnDomain()

    // DO NOT REMOVE BELOW CODE, IT'S FOR LICENSE USED
    // eslint-disable-next-line
    // apg_162a63e8_2cd9_4099_95dd_08cf009a0263.init()
    // eslint-disable-next-line
    anj_9b71cd6e_8774_4a76_a655_2ade6138fae4.init()
    // eslint-disable-next-line
    anj_5c72c516_517d_4335_bac9_33b0f916b5c3.init() 

    window.__lc = window.__lc || {}
    window.__lc.license = this.licenseId

    ;(function(n, t, c) {
      function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: '2.0', on: function() { i(['on', c.call(arguments)]) }, once: function() { i(['once', c.call(arguments)]) }, off: function() { i(['off', c.call(arguments)]) }, get: function() { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(['get', c.call(arguments)]) }, call: function() { i(['call', c.call(arguments)]) }, init: function() {
        var n = t.createElement('script'); n.async = !0; n.type = 'text/javascript'; n.src = 'https://cdn.livechatinc.com/tracking.js'; t.head.appendChild(n)
      } }; !n.__lc.asyncInit && e.init(); n.LiveChatWidget = n.LiveChatWidget || e
    }(window, document, [].slice))

    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'minimized':
          LiveChatWidget.call('hide')
          break
        case 'hidden':
          break
      }
    }

    // Wait for LiveChatWidget to be ready before setting up events and hiding
    LiveChatWidget.on('ready', () => {
      LiveChatWidget.on('visibility_changed', onVisibilityChanged)
      LiveChatWidget.call('hide')
    })
  },
  created() {
    getTypeMenuInfo().then((response) => {
      this.$store.commit('SET_GAME_TYPE', response.data.data)
    })

    getCategory().then((response) => {
      this.$store.commit('SET_GAME_CATEGORY', response.data.data)
    })

    // main image
    if (this.brandImage !== null) {
      this.main_image = this.brandImage
    }
  },
  methods: {
    goHelpCenter() {
      const isGuest = !this.token
      const user = this.user
      const userInfo = this.user.memberInfo
      const vipInfo = this.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, this.banner, user, userInfo, vipInfo, dateFormatter)
    },
    showText(key) {
      return this.$t(key) && this.$t(key).trim().length > 0
    },
    newWindows(obj) {
      return newWindows(obj)
    },
    showSealBasedOnDomain() {
      const currentDomain = window.location.hostname
      const seal1 = document.getElementById('anj-9b71cd6e-8774-4a76-a655-2ade6138fae4')
      const seal2 = document.getElementById('anj-5c72c516-517d-4335-bac9-33b0f916b5c3')

      if (currentDomain === 'www.katsuwin.io') {
        seal1.style.display = 'inline-block'
        seal2.style.display = 'none'
      } else if (currentDomain === 'www.katsuwin.ai') {
        seal1.style.display = 'none'
        seal2.style.display = 'inline-block'
      } else {
        seal1.style.display = 'inline-block'
        seal2.style.display = 'none'
      }
    },
    checkTokenUrl(licenseId) {
      let url = new URL(this.quickBars[0].url)
      // Update the pathname with the dynamic licenseId
      url.pathname = `/licence/${licenseId}/v2/open_chat.cgi`
      // If there's a token, handle it
      if (this.token) {
        // Assuming handleTokenUrl is a function that adds the token to the URL
        url = new URL(handleTokenUrl(url.toString(), this.token))
      }
      // Update the quickBars array with the new URL
      this.quickBars[0].url = url.toString()
      this.$store.commit('SET_URLINFO_CSURL', this.quickBars[0].url)
    },
    changeGameType(item) {
      item.attribute = 'type'
      this.$store.commit('SET_CURRENT_GAME_TYPE', item)

      if (this.path === '/landing') {
        localStorage.setItem('fromLandingPage', true)
      }

      if (this.path !== '/') {
        this.$router.push('/')
      }
    },
    getThemeImagePath
  }
}
</script>
